import { parsePersianNumber, formatPersianNumber } from "../utils/persianNumber";

const normalizeSearchText = (value) => String(value || "")
  .trim()
  .toLocaleLowerCase("fa-IR")
  .replace(/ي/g, "ی")
  .replace(/ك/g, "ک");

export const getCategoryKey = (category) => String(category?._id || category?.name || "");

export const projectMenuItems = (categories = [], { categoryKey = "all", query = "" } = {}) => {
  const normalizedQuery = normalizeSearchText(query);
  const selectedCategories = categoryKey === "all"
    ? categories
    : categories.filter((category) => getCategoryKey(category) === String(categoryKey));

  return selectedCategories.flatMap((category) => (category.items || []).filter((item) => {
    if (!normalizedQuery) return true;
    return [item.name, item.description]
      .some((value) => normalizeSearchText(value).includes(normalizedQuery));
  }));
};

export const formatPersianPrice = (value) => {
  const amount = parsePersianNumber(value) ?? 0;
  return `${formatPersianNumber(amount)} تومان`;
};

export const getCartSummary = (cart = []) => cart.reduce((summary, item) => {
  const quantity = Number(item?.quantity);
  const price = Number(item?.price);
  if (!Number.isInteger(quantity) || quantity <= 0 || !Number.isFinite(price) || price < 0) return summary;
  return {
    itemCount: summary.itemCount + quantity,
    total: summary.total + (price * quantity),
  };
}, { itemCount: 0, total: 0 });

export const parseTableNumber = (search = "") => {
  const rawValue = new URLSearchParams(search).get("table");
  const tableNumber = parsePersianNumber(rawValue);
  return Number.isInteger(tableNumber) && tableNumber > 0 ? tableNumber : null;
};
